import PropTypes from 'prop-types';
import { ORIENTATION_LEFT_TO_RIGHT } from '../constants';
import { PointShape, OrientationShape, RawNodeDatumShape, PathFuncShape } from '../propTypes';

export const defaultProps = {
  onNodeClick: undefined,
  onNodeMouseOver: undefined,
  onNodeMouseOut: undefined,
  onLinkClick: undefined,
  onLinkMouseOver: undefined,
  onLinkMouseOut: undefined,
  onUpdate: undefined,
  orientation: ORIENTATION_LEFT_TO_RIGHT,
  translate: { x: 0, y: 0 },
  pathFunc: 'diagonal',
  pathClassFunc: undefined,
  transitionDuration: 500,
  depthFactor: undefined,
  collapsible: true,
  initialDepth: undefined,
  zoomable: true,
  zoom: 1,
  scaleExtent: { min: 0.1, max: 1 },
  nodeSize: { x: 140, y: 140 },
  separation: { siblings: 1, nonSiblings: 2 },
  shouldCollapseNeighborNodes: false,
  svgClassName: '',
  rootNodeClassName: '',
  branchNodeClassName: '',
  leafNodeClassName: '',
  renderCustomNodeElement: undefined,
  enableLegacyTransitions: false,
  shouldResize: false,
  addNodeEnabled: false,
  leafPadding: 0,
};

export const propTypes = {
  data: PropTypes.oneOfType([RawNodeDatumShape, PropTypes.arrayOf(RawNodeDatumShape)]),
  renderCustomNodeElement: PropTypes.func,
  onNodeClick: PropTypes.func,
  onNodeMouseOver: PropTypes.func,
  onNodeMouseOut: PropTypes.func,
  onLinkClick: PropTypes.func,
  onLinkMouseOver: PropTypes.func,
  onLinkMouseOut: PropTypes.func,
  onUpdate: PropTypes.func,
  orientation: OrientationShape,
  translate: PointShape,
  pathFunc: PathFuncShape,
  pathClassFunc: PropTypes.func,
  depthFactor: PropTypes.number,
  collapsible: PropTypes.bool,
  initialDepth: PropTypes.number,
  zoomable: PropTypes.bool,
  zoom: PropTypes.number,
  scaleExtent: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
  }),
  nodeSize: PointShape,
  separation: PropTypes.shape({
    siblings: PropTypes.number,
    nonSiblings: PropTypes.number,
  }),
  shouldCollapseNeighborNodes: PropTypes.bool,
  svgClassName: PropTypes.string,
  rootNodeClassName: PropTypes.string,
  branchNodeClassName: PropTypes.string,
  leafNodeClassName: PropTypes.string,
  enableLegacyTransitions: PropTypes.bool,
  transitionDuration: PropTypes.number,
  generateTreePostProcess: PropTypes.func,
  onResizeLayout: PropTypes.func,
  treeId: PropTypes.string,
  shouldResize: PropTypes.bool,
  addNodeEnabled: PropTypes.bool,
  leafPadding: PropTypes.number,
};
